
(() => {
  if (window.LittleBuckBagAddon) return;
  window.LittleBuckBagAddon = true;

  let updating = false;

  const getCart = async () => {
    const response = await fetch(
      window.Shopify.routes.root + 'cart.js'
    );
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  };

  const updateBag = async (addon, variantId, quantity) => {
    const error = addon.querySelector('[data-lb-bag-error]');
    const checkbox = addon.querySelector('[data-lb-bag-checkbox]');
    const selector = addon.querySelector('[data-lb-bag-variant]');

    if (updating) return;

    updating = true;
    checkbox.disabled = true;
    selector.disabled = true;
    error.hidden = true;

    try {
      const cart = await getCart();
      const productId = Number(addon.dataset.bagProductId);

      const existingBags = cart.items.filter(
        item => item.product_id === productId
      );

      // Remove existing bag variants.
      for (const item of existingBags) {
        const response = await fetch(
          window.Shopify.routes.root + 'cart/change.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          }
        );

        if (!response.ok) {
          throw new Error('Unable to update bag');
        }
      }

      // Add the selected colour if checked.
      if (quantity > 0) {
        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1
              }]
            })
          }
        );

        if (!response.ok) {
          throw new Error('Unable to add bag');
        }
      }

      // Reload to display the updated cart.
      document.dispatchEvent(
  new CustomEvent('theme:cart:refresh', {
    bubbles: true
  })
);

checkbox.disabled = false;
selector.disabled = false;
updating = false;

    } catch (err) {
      console.error('Bag update failed:', err);

      error.textContent =
        'We could not update your bag. Please try again.';
      error.hidden = false;

      checkbox.disabled = false;
      selector.disabled = false;
      updating = false;
    }
  };

  // Handle checkbox and dropdown changes.
  document.addEventListener('change', event => {
    const addon = event.target.closest('[data-lb-bag-addon]');
    if (!addon) return;

    const checkbox = addon.querySelector('[data-lb-bag-checkbox]');
    const selector = addon.querySelector('[data-lb-bag-variant]');
    const options = addon.querySelector('[data-lb-bag-options]');

    if (event.target === checkbox) {
      options.hidden = !checkbox.checked;

      updateBag(
        addon,
        selector.value,
        checkbox.checked ? 1 : 0
      );
    }

    if (event.target === selector && checkbox.checked) {
      updateBag(addon, selector.value, 1);
    }
  });

  // Restore checkbox and dropdown after reload.
  const restoreState = async () => {
    const addons = document.querySelectorAll('[data-lb-bag-addon]');
    if (!addons.length) return;

    try {
      const cart = await getCart();

      addons.forEach(addon => {
        const productId = Number(addon.dataset.bagProductId);

        const bag = cart.items.find(
          item => item.product_id === productId
        );

        const checkbox = addon.querySelector('[data-lb-bag-checkbox]');
        const selector = addon.querySelector('[data-lb-bag-variant]');
        const options = addon.querySelector('[data-lb-bag-options]');

        checkbox.checked = Boolean(bag);
        options.hidden = !bag;

        if (bag) {
          selector.value = String(bag.variant_id);
        }
      });

    } catch (err) {
      console.warn('Unable to restore bag selection', err);
    }
  };
document.addEventListener('theme:cart:change', () => {
  restoreState();
});
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreState);
  } else {
    restoreState();
  }
})();
